<template>
  <div :class="$style.root">
    <CoreBlocksWorksGroupComponent
      v-if="showFloorsIfGardenIsPresent"
      :entries="groundFloorEntries"
      :childPageName="childPageName"
    >
      <SvgoFloorplanGroundFloor :class="$style.svg" />
    </CoreBlocksWorksGroupComponent>

    <CoreBlocksWorksGroupComponent
      v-if="showFloorsIfGardenIsPresent"
      :entries="firstFloorEntries"
      :childPageName="childPageName"
    >
      <SvgoFloorplanFirstFloor :class="$style.svg" />
    </CoreBlocksWorksGroupComponent>

    <CoreBlocksWorksGroupComponent
      v-if="showFloorsIfGardenIsPresent"
      :entries="secondFloorEntries"
      :childPageName="childPageName"
    >
      <SvgoFloorplanSecondFloor :class="$style.svg" />
    </CoreBlocksWorksGroupComponent>

    <CoreBlocksWorksGroupComponent
      v-if="gardenEntries?.length"
      :class="$style.garden"
      :entries="gardenEntries"
      :childPageName="childPageName"
      data-type="garden"
      :style="{
        '--width': svgWidth
      }"
    >
      <img
        :class="$style.svg"
        src="/Woonhuis-Floorplan-outside.svg"
        alt=""
      />
    </CoreBlocksWorksGroupComponent>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object,
  childPageName: String
})

const entries = computed(() => {
  return i18nGetLocalizedData(props?.block)?.entries?.data
})

const groundFloorEntries = computed(() => {
  return entries?.value?.filter(i => i?.attributes?.floor === 'ground_floor')
})

const firstFloorEntries = computed(() => {
  return entries?.value?.filter(i => i?.attributes?.floor === 'first_floor')
})

const secondFloorEntries = computed(() => {
  return entries?.value?.filter(i => i?.attributes?.floor === 'second_floor')
})

const gardenEntries = computed(() => {
  return entries?.value?.filter(i => i?.attributes?.floor === 'garden')
})

const showFloorsIfGardenIsPresent = computed(() => {
  if (gardenEntries?.value?.length) {
    return groundFloorEntries?.value?.length || firstFloorEntries?.value?.length || secondFloorEntries?.value?.length
  }
  return true
})

const svgWidth = (953.2922/10011.291) * 1000 + '%'
</script>

<style module lang="scss">
.root {
  padding: 0 var(--unit--horizontal--tripple);

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: var(--unit--horizontal--tripple);
  grid-row-gap: var(--unit--vertical--sextuple);

  @media (max-width: $breakpoint-m) {
    grid-template-columns: 1fr;
  }
}

.group {
  display: flex;
  flex-direction: column;

  position: relative;
}

.index {
  grid-column: 1 / -1;
}

.svg {
  fill: currentColor;
}

.garden {
  grid-column: 1 / -1;
}

// .gardenSvg {
//   width: calc(var(--width, 100%) - (var(--unit--horizontal--tripple) * 2));
//   margin: auto;
//   @media (max-width: $breakpoint-m) {
//     width: 100%;
//   }
// }
</style>
